import i18n from 'config/i18n';
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { endDateAfterStartDate, isValidDate } from 'utils/yup';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    startDate: isValidDate('startDate'),
    startTime: yup
      .mixed<Dayjs>()
      .default(dayjs().startOf('day'))
      .test(
        'startTime-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    noEndDate: yup.boolean().default(() => true),
    endDate: yup.mixed<Dayjs>().when('noEndDate', {
      is: (noEndDate: boolean) => noEndDate,
      then: yup.mixed<Dayjs>().notRequired(),
      otherwise: endDateAfterStartDate({
        compareToFieldName: 'startDate',
        startDateTranslation: 'startDate',
        endDateTranslation: 'endDate'
      })
    }),
    endTime: yup
      .mixed<Dayjs>()
      .default(dayjs().endOf('day'))
      .test(
        'endTime-valid',
        () => t('invalidDate'),
        (v, ctx) => ctx.parent.noEndDate || (v ? v.isValid() : false)
      ),
    reasonId: yup
      .string()
      .required(t('validationFieldRequired', { name: t('reason') })),
    description: yup.string(),
    absentAppointments: yup.array().of(
      yup.object({
        id: yup
          .string()
          .required(t('validationFieldRequired', { name: t('id') })),
        originalId: yup
          .string()
          .required(t('validationFieldRequired', { name: t('originalId') }))
      })
    ),
    absenceAppointmentType: yup
      .mixed<'SINGLE' | 'ALL'>()
      .when(['isNewAppointmentAbsence'], {
        is: (isNewAppointmentAbsence?: boolean) => !!isNewAppointmentAbsence,
        then: yup.mixed<'SINGLE' | 'ALL'>().required(
          t('validationFieldRequired', {
            name: t('activityPlanning.absenceAppointmentType')
          })
        ),
        otherwise: yup.mixed<'SINGLE' | 'ALL'>().notRequired()
      })
  });
};

export default getSchema;
